export const CHANGE_IS_SIGN_IN = 'CHANGE_IS_SIGN_IN';
export const CHANGE_USERNAME = 'CHANGE_USERNAME';
export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';